<template>
    <div v-if="visible" class="preview-container" @click.stop="previewClick($event)">
        <span class="preview-close" @click.stop="closeClick"></span>
        <img class="preview-img" :src="src" />
    </div>
</template>

<script>
export default {
    // @Prop({ default: '' }) private src!: string; //地址
    // @Prop({ default: false }) private visible!: boolean; //显示状态
    // @Prop({ default: false }) private closeOnClickModal!: boolean; //是否可以通过点击背景关闭
    props: {
        src: {
            type: String,
            default: ''
        },
        visible: {
            type: Boolean,
            default: false
        },
        closeOnClickModal: {
            type: Boolean,
            default: false
        }
    },

    methods: {
        //按钮点击
        closeClick() {
            this.closeView();
        },

        //视窗点击
        previewClick(e) {
            if (this.closeOnClickModal) {
                //如果点击的元素是preview-container
                if (Array.prototype.includes.call(e.target.classList, 'preview-container')) {
                    this.closeView();
                }
            }
        },  

        //关闭图片查看
        closeView() {
            this.$emit('update:visible', false);
        }
    }
}
</script>

<style lang="scss" scoped>
.preview-container {
    display: flex;
    align-items: center;
    justify-content: center;
    position: fixed;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    z-index: 999;
    overflow: hidden;
    background-color: rgba(#000, 0.5);

    .preview-img {
        max-width: 100%;
        max-height: 100%;
    }

    .preview-close {
        position: absolute;
        right: 0;
        top: 0;
        width: 32px;
        height: 32px;
        background-color: rgba(#000, 0.5);

        &:hover {
            background-color: rgba(#000, 0.8);
            cursor: pointer;
        }
        &::before,
        &::after {
            content: '';
            position: absolute;
            left: 50%;
            top: 50%;
            width: 0;
            height: 60%;
            border-right: 1px solid #fff;
            font-size: 0;
        }
        &::before {
            transform: translate(-50%, -50%) rotate(-45deg);
        }
        &::after {
            transform: translate(-50%, -50%) rotate(45deg);
        }
    }
}
</style>




// WEBPACK FOOTER //
// src/components/PicturePreview/PicturePreview.vue